// @module ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay
define("ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay.View", [
  "room4_ccaproductimageeventoverlay_ccaproductimageeventoverlay.tpl",
  "SCView",
], function (
  room4_ccaproductimageeventoverlay_ccaproductimageeventoverlay_tpl,
  SCViewModule,
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  function OverlayView(config) {
    SCView.call(this, config);
    this.timezone = config.timezone;
    this.template =
      room4_ccaproductimageeventoverlay_ccaproductimageeventoverlay_tpl;
    this.contextDataRequest = ["item"];
  }

  OverlayView.prototype = Object.create(SCView.prototype);
  OverlayView.prototype.constructor = OverlayView;

  /**
   * Parses a date string in the format "DD/MM/YYYY" and returns the UTC milliseconds,
   * adjusted for the specified timezone. If parsing fails, returns the default value.
   * CAUTION: date format can be changed in company settings.
   * @param {string} dateString
   * @param {number} defaultValue
   * @returns {number}
   */
  OverlayView.prototype.parseDateOrDefault = function (
    dateString,
    defaultValue,
  ) {
    if (!dateString) {
      return defaultValue;
    }
    var parts = dateString.split("/");
    if (parts.length !== 3) {
      return defaultValue;
    }
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);
    if (!day || !month || !year) {
      return defaultValue;
    }
    var tz = this.timezone || "+00:00";
    var tzMatch = /^([+-])(\d{2}):(\d{2})$/.exec(tz);
    if (!tzMatch) {
      return defaultValue;
    }
    var sign = tzMatch[1] === "-" ? -1 : 1;
    var hours = parseInt(tzMatch[2], 10);
    var minutes = parseInt(tzMatch[3], 10);
    if (isNaN(hours) || isNaN(minutes)) {
      return defaultValue;
    }
    var offsetMinutes = sign * (hours * 60 + minutes);
    var utcMillis = Date.UTC(year, month - 1, day) - offsetMinutes * 60000;
    if (isNaN(utcMillis)) {
      return defaultValue;
    }
    return utcMillis;
  };

  OverlayView.prototype.getContext = function () {
    var startDate = this.parseDateOrDefault(
      this.contextData.item().custitem_promo_start_date,
      0,
    );
    var endDate = this.parseDateOrDefault(
      this.contextData.item().custitem_promo_end_date,
      Number.MAX_VALUE,
    );
    var now = Date.now();
    var promotionImage =
      startDate <= now && now <= endDate
        ? this.contextData.item().custitem27
        : null;
    // Check if current date is within promotion dates
    var clearance = this.contextData.item().custitem6;
    var clearanceImage = clearance
      ? "https://www.canadacustomautoworks.com/site/promotion-images/clearance/clearance.png"
      : null;

    return {
      promotionImage: promotionImage,
      clearance: clearance,
      clearanceImage: clearanceImage,
    };
  };

  return OverlayView;
});
